<template>
  <div
    :class="`menu-toggle ${toggleIsOpen && 'menu-toggle--is-open'}`"
    @click="handleClick"
  >
    <span class="menu-toggle__icon" />
    <span class="menu-toggle__icon" />
    <span class="menu-toggle__icon" />
  </div>
</template>

<script>
export default {
  props: {
    toggleIsOpen: Boolean
  },
  methods: {
    handleClick() {
      this.$emit("handleClick");
    }
  }
};
</script>

<style lang="scss" scoped>
.menu-toggle {
  display: none;
  min-width: 24px;
  width: 24px;
  height: 24px;
  margin-left: 30px;
  cursor: pointer;
  @media (max-width: $breakpoint-sm - 1) {
    display: block;
  }
}

.menu-toggle--is-open {
  .menu-toggle__icon {
    background-color: $--color-white;
  }

  .menu-toggle__icon:first-child {
    top: 7px;
    transform: rotate(45deg);
  }
  .menu-toggle__icon:nth-child(2) {
    opacity: 0;
    right: -100%;
  }

  .menu-toggle__icon:last-child {
    bottom: 7px;
    transform: rotate(-45deg);
  }
}

.menu-toggle__icon {
  position: relative;
  margin-top: 3px;
  margin-bottom: 3px;
  display: block;
  height: 2px;
  width: 100%;
  background-color: $--color-landing-primary;
  transition: all 0.2s ease-in-out;
}

.menu-toggle__icon:nth-child(2) {
  right: 0;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 19px;
  margin-left: auto;
  opacity: 1;
}
</style>
